import { authInstanceOrg, unauthInstanceOrg } from 'api/axios.config'

export const setOrgUrl = (url: string) => {
  authInstanceOrg.defaults.baseURL = url
  unauthInstanceOrg.defaults.baseURL = url
}
